@for (bubble of bubbles(); track bubble) {
  <div class="audio-bubble absolute inset-0 size-[100%] rounded-full" [class]="color()" (animationend)="remove(bubble)"></div>
}
